export default function (props) {
    return (
        <>
            <div className="border-[#0094D84D] border-2 bg-[#F1F8FF] p-4 relative mb-4">
                <svg className={'absolute top-[-12px] left-[-12px]'} xmlns="http://www.w3.org/2000/svg" width="24"
                     height="24" fill="none">
                    <g clipPath="url(#a)">
                        <rect width="24" height="24" fill="#F1F8FF" rx="12"/>
                        <path fill="url(#b)"
                              d="M12 23.792A11.792 11.792 0 1 1 23.792 12 11.807 11.807 0 0 1 12 23.792Zm0-22.22A10.468 10.468 0 1 0 22.468 12.04 10.476 10.476 0 0 0 12 1.572Z"/>
                        <path fill="url(#c)" d="M12 6.328a1.2 1.2 0 1 0 0 2.4 1.2 1.2 0 0 0 0-2.4Z"/>
                        <path fill="url(#d)"
                              d="M12 10.508a.896.896 0 0 0-.896.896v5.372a.896.896 0 0 0 1.792 0v-5.372a.896.896 0 0 0-.897-.896Z"/>
                    </g>
                    <defs>
                        <linearGradient id="b" x1=".208" x2="23.792" y1="12" y2="12" gradientUnits="userSpaceOnUse">
                            <stop offset=".02" stop-color="#3DC6EF"/>
                            <stop offset="1" stop-color="#0094D8"/>
                        </linearGradient>
                        <linearGradient id="c" x1="10.804" x2="13.196" y1="7.52" y2="7.52"
                                        gradientUnits="userSpaceOnUse">
                            <stop offset=".02" stop-color="#3DC6EF"/>
                            <stop offset="1" stop-color="#0094D8"/>
                        </linearGradient>
                        <linearGradient id="d" x1="11.104" x2="12.896" y1="14.092" y2="14.092"
                                        gradientUnits="userSpaceOnUse">
                            <stop offset=".02" stop-color="#3DC6EF"/>
                            <stop offset="1" stop-color="#0094D8"/>
                        </linearGradient>
                        <clipPath id="a">
                            <rect width="24" height="24" fill="#fff" rx="12"/>
                        </clipPath>
                    </defs>
                </svg>


                {props.children}
            </div>

        </>
    )
}
